'use client'

import { InterfaceChainUtils } from '@morpho-org/dapp-core'
import { useEffect } from 'react'

import { useWeb3Context } from '@/contexts/Web3Context/Web3.context'

/**
 * Initializes the target chain from the URL's chainIdentifier param.
 * Rendered once at the [chainIdentifier] layout level so every
 * chain-specific page inherits the correct chain on mount.
 */
export function ChainInitializer({ chainIdentifier }: { chainIdentifier: string }) {
  const { onSetTargetChain } = useWeb3Context()

  useEffect(() => {
    const chain = InterfaceChainUtils.tryGetChain(chainIdentifier)

    if (!chain) return

    // No user gesture here, so a failed switch stays quiet; WrongNetworkButton offers the retry.
    onSetTargetChain(chain, { silent: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainIdentifier])

  return null
}
